<template>
  <!-- 团财续保管理 -->
  <div class="renewManage main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item select-two">
          <Select class="input-item-select" style="width: 110px" :transfer="true" v-model="searchParams.policyNoSelect">
            <Option value="1" label="原保单号"></Option>
            <Option value="2" label="新保单号"></Option>
          </Select>
          <Input v-model="searchParams.policyNumber" clearable placeholder="请输入" />
        </div>
        <div class="input-item select-two">
          <Select class="input-item-select" style="width: 130px" :transfer="true" v-model="searchParams.multiple">
            <Option value="1" label="原单到期日"></Option>
            <Option value="2" label="实际续保日"></Option>
          </Select>
          <DatePicker
            :clearable="true"
            :transfer="true"
            separator="至"
            type="daterange"
            v-model="searchParams.multipleDate"
            format="yyyy-MM-dd"
            placeholder="请选择时间"
          ></DatePicker>
        </div>

        <div class="input-item">
          <span class="label">保险公司</span>
          <Select clearable v-model="searchParams.companyCode" filterable>
            <Option :value="item.code" v-for="(item, index) in companyList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">投保人</span>
          <Input v-model="searchParams.holderName" placeholder="请输入投保人名称" clearable />
        </div>
        <div class="input-item">
          <span class="label">原产品名称/code</span>
          <Select v-model="searchParams.productCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in productList" :key="i" :value="item.productCode">{{ item.productName }}({{ item.productCode }})</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">保单状态</span>
          <Select clearable v-model="searchParams.status">
            <Option :value="item.value" v-for="(item, index) in policyStatusList" :key="index">{{ item.label }}</Option>
          </Select>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>

      <Tabs class="tabs" v-model="searchParams.payState" @on-click="searchAjax()" :animated="false">
        <TabPane :label="'即将到期(' + (countObj.waitNum || '0') + ')'" name="1"></TabPane>
        <TabPane :label="'已续保(' + (countObj.successNum || '0') + ')'" name="2"></TabPane>
        <TabPane :label="'未续保(' + (countObj.failNum || '0') + ')'" name="3"></TabPane>

        <div class="right" slot="extra">
          <Button type="primary" ghost @click="exportExcel">导出 </Button>
        </div>
      </Tabs>

      <div class="tipBox clearfix">
        <div class="left clearfix" v-if="searchParams.payState == '2'">
          <div>
            原单保费：
            <span class="other">{{ countObj.fee }}</span
            >元
          </div>

          <div>
            续保保费：
            <span class="other">{{ countObj.payFee }}</span
            >元
          </div>

          <div>
            原单服务费：
            <span class="other">{{ countObj.commissionPrice }}</span
            >元
          </div>
          
          <div>
            新单服务费：
            <span class="other">{{ countObj.newCommissionPrice }}</span
            >元
          </div>
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="holderName">
            <span>{{ row.holderName || '-' }}</span>
          </template>
          <template slot-scope="{ row }" slot="productName">
            <div>{{ row.productName }}({{ row.productCode }})</div>
          </template>
          <template slot-scope="{ row }" slot="policyNo">
            <a class="policy-no" @click="toDetail(row)">{{ row.policyNo }}</a>
          </template>
          <template slot-scope="{ row }" slot="newPolicyNo">
            <a class="policy-no" @click="goPolicyDetail(row)" v-if="row.newPolicyNo">{{ row.newPolicyNo }}</a>
            <span v-else>-</span>
          </template>
          <template slot-scope="{ row }" slot="endDesc">
            <span v-if="row.dayNum <= 5" class="date-dian" :style="{ background: '#ED0000' }"></span>
            <span v-else-if="row.dayNum > 5 && row.dayNum <= 7" class="date-dian" :style="{ background: '#FF750D' }"></span>
            <span v-else-if="row.dayNum > 7" class="date-dian" :style="{ background: '#66DD2A' }"></span>
            <span class="end-desc">{{ row.endDesc }}</span>
            <p>({{ row.endTime | filterTime('YYYY-MM-DD') }})</p>
          </template>
          <template slot-scope="{ row }" slot="action">
            <!-- 即将到期 -->
            <div class="detail" v-if="row.payState == 1">
              <!-- sourceType 1-桐心保平台单 2-商户录单 -->
              <template v-if="row.sourceType == 1">
                <div @click="generateOrder(row)">生成续保订单</div>
                <div @click="goOrderList(row)">查看续保订单</div>
              </template>
              <span v-else>-</span>
            </div>
            <!-- 已续保 -->
            <div class="detail" v-if="row.payState == 2">
              <div @click="goOrderList(row)">查看续保订单</div>
            </div>
            <!-- 未续保 -->
          </template>
        </Table>
      </div>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filters from '@/api/filter';
import { config } from './index.config.js';
export default {
  mixins: [config, pageTool, common],
  components: {},
  data() {
    return {
      companyList: [], //保险公司
      policyStatusList: [
        {
          label: '已承保',
          value: '1'
        },
        {
          label: '已退保',
          value: '-1'
        },
        {
          label: '已终止',
          value: '0'
        }
      ],
      productList: [], //产品列表
      countObj: {},
      searchParams: {
        multiple: '1',
        policyNoSelect: '1',
        payState: '1',
        pageNo: 1,
        pageSize: 10
      }
    };
  },

  async created() {
    this.getProductList();
    this.queryAllCompany();
    this.initListParams('/buz/groupPolicyRenewalRecord/read/list');
  },

  activated() {
    this.getList();
  },

  methods: {
    // 产品列表
    getProductList() {
      this.$http({
        url: `/buz/productBase/read/groupList`,
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        this.productList = res.data;
      });
    },
    // 获取保司
    async queryAllCompany() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 处理时间参数
    setListParams(params) {
      this.getColumns();
      // 原单到期日
      if (params.multiple == 1 && params.multipleDate && params.multipleDate[0]) {
        params.endTimeStart = filters.filterTime(params.multipleDate[0], 'YYYY-MM-DD');
        params.endTimeEnd = filters.filterTime(params.multipleDate[1], 'YYYY-MM-DD');
      } else if (params.multiple == 2 && params.multipleDate && params.multipleDate[0]) {
        // 实际续保日
        params.payTimeStart = filters.filterTime(params.multipleDate[0], 'YYYY-MM-DD');
        params.payTimeEnd = filters.filterTime(params.multipleDate[1], 'YYYY-MM-DD');
      }
      delete params.multipleDate;
      delete params.multiple;
      // 原保单单号
      if (params.policyNoSelect == 1 && params.policyNumber) {
        params.policyNo = params.policyNumber;
      } else if (params.policyNoSelect == 2 && params.policyNumber) {
        //续保单单号
        params.newPolicyNo = params.policyNumber;
      }
      delete params.policyNoSelect;
      delete params.policyNumber;
    },
    listCallback() {
      this.getStatisticsData();
    },

    // 续保列表数据
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$http({
        url: '/buz/policyShortRenewalRecord/read/list',
        type: 'POST',
        data: params,
        apiPermissionCode: 'renewalManage_01_0'
      })
        .then(res => {
          this.getStatisticsData();
          this.$root.$children[0].isShowLoading = false;
          this.tableDate = res.data;
          this.total = res.total;
        })
        .catch(e => {
          console.log(e);
          this.$root.$children[0].isShowLoading = false;
        });
    },
    // 统计
    getStatisticsData() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$http({
        url: '/buz/groupPolicyRenewalRecord/statistics',
        type: 'POST',
        data: params
      }).then(res => {
        this.countObj = res.data;
      });
    },

    // 导出
    exportExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/groupPolicyRenewalRecord/export', params, 'POST');
    },

    // 详情
    toDetail(row) {
      this.$router.push({
        path: '/renewalManage/renewalGroupManage/detail',
        query: {
          id: row.id,
          status: this.searchParams.payState
        }
      });
    },
    // 生成订单
    generateOrder(row) {
      const close = this.$notice.loading();
      this.$http({
        url: '/buz/groupPolicyRenewalRecord/generateRenewalOrder',
        type: 'POST',
        data: {
          id: row.id,
          policyNo: row.policyNo
        }
      }).then(res => {
        window.open(res.data);
        this.getList();
      }).finally(()=>{
        close();
      });
    },
    // 跳转订单列表
    goOrderList(row) {
      if (!row.orderId) {
        this.$notice.error('暂未创建续保订单');
        return;
      }
      sessionStorage.queryOrderNo = row.orderId;
      this.$router.push({
        path: '/orderManage/group/order'
      });
    },
    // 跳转保单详情
    goPolicyDetail(row) {
      this.$router.push({
        path: '/orderManage/group/policyDetail',
        query: {
          backUrl: this.delQueStr(this.$route.fullPath, 'time'),
          id: row.newId || '',
          policyNo: row.newPolicyNo,
          orderNo: row.orderId
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>